import { qoffline } from "../shared/qrequest";
import BaseCom from "./BaseCom";

export default class Offline extends BaseCom {
    componentDidUpdate(prevProps,prevState) {
        if(prevState.offline !== qoffline()) {
            this.setState({ offline: qoffline() });
        }
    }

    render() {
        if(!this.state.offline) return;
        return <div className="app-offline">Offline Mode</div>;
    }
}